import { Button, Card, Spinner, Typography } from "@material-tailwind/react";
import React, { useEffect, useState } from "react";
import { useShared } from "../../hooks/useShared";
import { useForm } from "react-hook-form";
import { ToastContainer, toast } from "react-toastify";
import ASelect from "../../components/fields/ASelect";
import AIcon from "../../components/partials/AIcon";
import AInput from "../../components/fields/AInput";
import ItemsComp from "./ItemsComp";
import UploadFiles from "../../components/upload/UploadFiles";
import { useParams } from "react-router-dom";
import axios from "axios";

const fields = {
  tariff_type: {
    label: "نوع تعـرفه",
    name: "tariff_type",
    type: "select",
    roles: [1],
    icon: "text-outline",
    className: "",
    required: "Please select Tariff type",
    options: []
  },
  name: {
    label: "اسم",
    name: "name",
    type: "text",
    roles: [1],
    icon: "text-outline",
    className: "",
    required: false,
    note: "(اگر شرکت نباشد، لطفا اسم شخص نوشته کنيد)"
  },
  company: {
    label: "شــرکت",
    name: "company",
    type: "select",
    roles: [1],
    icon: "text-outline",
    className: "",
    required: false,
    options: [],
    model: "tariff",
    isDisabled: false
  },
  items: {
    label: "اجناس",
    name: "items",
    type: "items_comp",
    roles: [1],
    icon: "text-outline",
    className: "",
    required: true,
    options: {
      head: ["نام جنس", "مقدار پول (؋)"],
      fields: { category: null, quantity: null }
    }
  },

  description: {
    label: "ملاحظات",
    name: "description",
    type: "textarea",
    roles: [1],
    icon: "book-outline",
    className: "",
    required: false,
    isStyle: false
  }
};

const itemTypes = {
  export: {
    head: ["نام جنس", "متراژ", "تفصيلات"],
    fields: { category: null, quantity: null, description: null },
    options: null
  },
  imports: {
    head: ["نام جنس", "کيـلوگرام", "تفصيلات"],
    fields: { category: null, quantity: null, description: null },
    options: null
  },
  membershipCard: { head: ["نام"], fields: { category: null }, options: null },
  rental: {
    head: ["نوع", "ملاحظات", "از تاريخ", " الی تاريخ", "مقدار پول (افغانی)"],
    fields: {
      category: null,
      description: null,
      from_date: null,
      to_date: null,
      price_per_unit: null
    },
    options: null
  },
  cleanliness: {
    head: ["نوع", "ملاحظات", "از تاريخ", " الی تاريخ", "مقدار پول (افغانی)"],
    fields: {
      category: null,
      description: null,
      from_date: null,
      to_date: null,
      price_per_unit: null
    },
    options: null
  },
  usd_tariff: {
    head: ["نام جنس", "مقدار پول ( $ )", "تفصيلات"],
    fields: { from_name: null, price_per_unit: null, description: null },
    options: null
  },
  others: {
    head: ["نام جنس", "مقدار پول (؋)"],
    fields: { from_name: null, price_per_unit: null },
    options: null
  }
};

export default function NewTariff({ v }) {
  const {
    http,
    navigate,
    com,
    auth,
    funs,
    location,
    setMessage,
    fetchModelCounts
  } = useShared();

  useEffect(() => {
    if (!auth.hasRole([1, 2, 4, 17])) {
      return navigate("/db/notAllowed");
    }
  }, []);

  const [errorMessage, setErrorMessage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [files, setFiles] = useState([]);
  const [items, setItems] = useState(null);
  const [tariff, setTariff] = useState(null);
  const [tariffTypes, setTariffTypes] = useState({ ...fields.tariff_type });
  const [companyInput, setCompanyInput] = useState({ ...fields.company });
  const { id } = useParams();

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    reset,
    setValue,
    getValues
  } = useForm({
    /* defaultValues: useMemo(() => {
            return location?.state?.model;
        }, [model]) */
  });

  //Renew rental
  const getRentals = () => {
    console.log(location?.state, id);
    if (location?.state?.action === "renew" && Number(id) === 0) {
      const mModel = { ...location?.state?.model };

      const item = { ...mModel?.rental_items };
      item.from_date = com?.dateConvert(item.to_date, false);
      item.to_date = null;
      const preItemID = item.id;
      item.id = null;
      reset({
        company: mModel?.company,
        name: mModel?.name,
        tariff_type: mModel?.tariff_type,
        items: [item],
        status: 0,
        preItemID
      });
      if (mModel?.tariff_type?.value === 82) {
        itemTypes.rental.options = [{ category: item.category }];
        setItems(itemTypes.rental);
      } else if (mModel?.tariff_type?.value === 82) {
        itemTypes.cleanliness.options = [{ category: item.category }];
        setItems(itemTypes.cleanliness);
      }

      console.log(mModel);
    }
  };

  const getCompanies = () => {
    if (companyInput.options?.length === 0) {
      //Normal User
      if (auth?.hasRole([4])) {
        http.get(`/api/companies?uId=${auth?.getUserID()}`).then(res => {
          console.log("get companies ", res);
          if (res.data.success) {
            if (res?.data?.data?.length > 0) {
              // setCompanyInput(pre=>({...pre, isDisabled:true, options:res.data.data}))
              setValue("company", res?.data?.data[0]);
            } else {
              if (auth?.hasRole([4]))
                setErrorMessage(
                  "شما شرکت خود را در ديتابيس ثبت نکرده اید! لطفا اول آن را ثبت کنید."
                );
              else {
                setErrorMessage(
                  "Please select a relevant company or fill the name field!"
                );
              }
            }
          }
        });
      } else if (auth?.hasRole([1, 2, 17])) {
        http.get(`/api/companies?nameId=true`).then(res => {
          console.log("get companies ", res);
          if (res.data.success) {
            setCompanyInput(pre => ({ ...pre, options: res.data.data }));
          }
        });
      }
    }
  };

  useEffect(() => {
    getRentals();
    getCompanies();
  }, []);

  const changeDates = data => {
    if (data?.items) {
      data?.items.map(it => {
        it["from_date"] = com?.dateConvert(it["from_date"], false);
        it["to_date"] = com?.dateConvert(it["to_date"], false);
      });
    }
    return data;
  };

  //Edit Tariff
  useEffect(() => {
    if (id > 0) {
      setTariff(null);
      setLoading(true);
      http.get(`/api/tariffs/${id}`).then(
        res => {
          console.log("get tariff ", res);
          if (res.data.success) {
            res.data.data = changeDates(res.data.data);
            setTariff(res.data.data);
            setFiles(res.data?.data?.attachments);
            tarrifTypeChange(res.data?.data?.tariff_type);
            reset(res.data.data);
          }
          setLoading(false);
        },
        err => {
          console.log("err");
          setLoading(false);
        }
      );
    }
  }, [id]);

  useEffect(() => {
    if (fields.tariff_type?.options?.length === 0) getItemCategories(20);
  }, [fields.tariff_type]);

  const mReset = () => {
    reset({});
  };

  const submit = async submitData => {
    console.log(submitData);
    setErrorMessage(null);
    funs?.getBla();
    console.log(funs.bla);
    const bla = funs?.bla;
    if (bla && (bla?.err?.status === 1 || bla.actions?.status === 1)) {
      console.log(bla);
      if (bla?.err?.status === 1) {
        setErrorMessage(bla?.err?.msg);
        toast.error(bla?.err?.msg);
      }
    } else {
      try {
        if (
          (submitData.name === null ||
            submitData.name === undefined ||
            submitData.name === "") &&
          (submitData?.company === null || submitData?.company === undefined)
        ) {
          return setErrorMessage(
            "شما شرکت خود را در ديتابيس ثبت نکرده اید! لطفا اول آن را ثبت کنید."
          );
        } else setErrorMessage(null);

        // convert rental FROM & TO dates to miladi
        if (
          submitData?.tariff_type?.value === 22 ||
          submitData?.tariff_type?.value === 82
        ) {
          const items = submitData?.items;
          items?.map((it, i) => {
            it["from_date"] = com?.dateConvert(it["from_date"]);
            it["to_date"] = com?.dateConvert(it["to_date"]);
            submitData.items[i] = it;
          });
        }

        setLoading(true);
        const res = await http.post(`api/tariffs`, submitData);

        console.log("tariff  ", res);

        if (res.data?.success) {
          const tariff = res.data?.data;
          setLoading(false);
          toast.success(res.data.message);
          setMessage(res.data.message);
          fetchModelCounts();
          if (tariff?.id && files?.length > 0) {
            uploadFiles(tariff);
          } else navigate(-1);
        }
      } catch (error) {
        console.log(error);
        setLoading(false);
        const err = error?.response?.data;

        if (!err?.success) {
          setErrorMessage(err?.message);
          toast.error(err?.message);
        }
      }
    }
    return false;
  };

  const uploadFiles = tariff => {
    if (tariff?.id && files?.length > 0) {
      let formData = new FormData();
      formData.append("model_name", "Tariff");
      formData.append("model_id", tariff.id);
      formData.append("TotalFiles", files.length);
      files.map((f, i) => {
        formData.append("files" + i, f.file);
        if (f.id) formData.append("aId" + i, f.id);
      });

      http.upload(`api/uploadFiles`, formData).then(res => {
        console.log(res);
        if (res.data.success) navigate(-1);
      });
    }
  };

  const getItemCategories = id => {
    http.post(`/api/categoryAdvanceSearch?typeId=${id}`).then(res => {
      console.log(id, "get getItemCategories ", res);
      if (res.data.success) {
        // setItemCategories(res.data.data)
        if (id === 25) {
          itemTypes.export.options = res.data.data;
          setItems(itemTypes.export);
        } else if (id === 30) {
          itemTypes.rental.options = res.data.data;
          setItems(itemTypes.rental);
        } else if (id === 84) {
          itemTypes.cleanliness.options = res.data.data;
          setItems(itemTypes.cleanliness);
        } else if (id === 35) {
          itemTypes.membershipCard.options = res.data.data;
          setItems(itemTypes.membershipCard);
        } else if (id === 89) {
          itemTypes.imports.options = res.data.data;
          setItems(itemTypes.imports);
        } else if (id === 20) {
          //  fields.tariff_type.options = res.data.data
          setTariffTypes(pre => ({ ...pre, options: res.data.data }));
        }
      }
    });
  };

  const tarrifTypeChange = e => {
    console.log("tarrifTypeChange ", e);
    setItems(null);

    setValue("tariff_type", e);

    //   fields.items.options =itemTypes.export
    switch (e?.value) {
      case 21: //export
        getItemCategories(25);
        break;
      case 88: //imports
        getItemCategories(89);
        break;
      case 22: // rental
        getItemCategories(30);
        break;

      case 82: // cleanliness of property
        getItemCategories(84);
        break;
      case 24: //membershipCard
        getItemCategories(35);
        break;

        case 96: //membershipCard
        setItems(itemTypes.usd_tariff);
        break;

      default:
        setItems(itemTypes.others);
        break;
    }
  };

  return (
    <>
      {tariff && tariff?.status !== 0 ? (
        <Card className="w-full p-2 md:p-4 mt-4 relative  ">
          {" "}
          <p>Once a tariff is approved, it cannot be edited.</p>
        </Card>
      ) : (
        <div>
          <div className="w-full grid  gap-4">
            <Card className="w-full p-2 md:p-4 mt-4 relative  ">
              <p className="text-sm text-main-color font-bold capitalize">
                Add / Update Tariff{" "}
              </p>
              <form
                className=" flex flex-col gap-4 mt-4"
                onSubmit={handleSubmit(submit)}
              >
                <fieldset className="border p-3 rounded-lg grid gap-4 ">
                  {companyInput?.options?.length > 0 && (
                    <ASelect
                      v={{ register, errors, control, data: companyInput }}
                    />
                  )}
                  {!auth?.hasRole([4]) && (
                    <AInput v={{ register, errors, data: fields.name }} />
                  )}
                  {tariffTypes?.options?.length > 0 && (
                    <ASelect
                      v={{ register, errors, control, data: tariffTypes }}
                      onChange={e => tarrifTypeChange(e)}
                    />
                  )}
                  {items && (
                    <ItemsComp
                      v={{
                        register,
                        errors,
                        control,
                        setValue,
                        data: items,
                        items: "items"
                      }}
                    />
                  )}

                  <AInput v={{ register, errors, data: fields.description }} />
                </fieldset>

                {tariff?.id > 0 && (
                  <UploadFiles v={{ files, setFiles, className: "" }} />
                )}

                {errorMessage && (
                  <Typography
                    variant="small"
                    style={{ direction: "rtl" }}
                    className="flex items-center text-red-500 gap-2 font-normal text-base "
                  >
                    <AIcon
                      name="alert-circle-outline"
                      className="-mt-0.5 h-4 w-4"
                    />
                    {errorMessage}
                  </Typography>
                )}
                <div className="flex gap-4 md:justify-start">
                  <Button
                    className="btn1 w-full md:w-[10%] amiriB text-white text-base"
                    size="sm"
                    type="submit"
                    disabled={loading}
                  >
                    {" "}
                    {loading ? (
                      <Spinner color="teal" className="h-4 w-4" />
                    ) : (
                      "ارسال"
                    )}{" "}
                  </Button>
                  <Button
                    variant="outlined"
                    size="sm"
                    color="gray"
                    onClick={() => mReset()}
                  >
                    Reset
                  </Button>
                </div>
              </form>
            </Card>
          </div>
          <ToastContainer />
        </div>
      )}
    </>
  );
}
